<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VueApexCharts,
    BCard,
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {
        chart: {
          type: 'pie',
        },
        labels: [],
        legend: {
          show: false, // Hide the legend
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.fetchData() // Default to last 7 days (handled in backend)
  },
  methods: {
    async fetchData(startDate, endDate) {
      try {
        const { data: { data } } = await this.$http.get('/v1/admin/info-sources-users', {
          params: { start_date: startDate, end_date: endDate },
        })

        this.chartOptions.labels = data.map(item => item.info_source)
        this.chartSeries = data.map(item => item.total)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Gagal memuat data',
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>

<template>
  <b-card
    class="card-tiny-line-stats"
  >
    <h6 class="mb-2">
      Dari mana tau Miniapoly?
    </h6>

    <vue-apex-charts
      v-if="chartSeries && chartSeries.length"
      :options="chartOptions"
      style="height: 200px"
      :series="chartSeries"
    />
  </b-card>
</template>

<style scoped lang="scss">

</style>
